<template>
  <section class="lead-flow-overview-section lead-trengo-origin">
    <h3>Trengo</h3>
    <dl>
      <div><dt>Original ticket</dt><dd><a :href="ticketUrl" target="_blank" rel="noopener noreferrer">#{{ origin.ticket_id }} ↗</a></dd></div>
      <div v-if="origin.channel"><dt>Channel</dt><dd>{{ origin.channel.name }}</dd></div>
      <div><dt>Lead manager</dt><dd>{{ origin.manager ? origin.manager.name : 'Not assigned' }}</dd></div>
      <div><dt>Assignment sync</dt><dd>{{ statusLabel }}</dd></div>
      <div v-if="origin.projected_assignee"><dt>Imported Trengo assignee</dt><dd>{{ origin.projected_assignee.name }}</dd></div>
      <div v-if="origin.projection_updated_at"><dt>Projection updated</dt><dd>{{ exact(origin.projection_updated_at) }}</dd></div>
      <div v-if="origin.sync.checked_at"><dt>Checked directly</dt><dd>{{ exact(origin.sync.checked_at) }}</dd></div>
      <div v-if="origin.sync.observed_user_id"><dt>Verified Trengo user</dt><dd>#{{ origin.sync.observed_user_id }}</dd></div>
      <div v-if="origin.sync.last_attempt_at"><dt>Last attempt</dt><dd>{{ exact(origin.sync.last_attempt_at) }}</dd></div>
      <div v-if="origin.sync.confirmed_at"><dt>Confirmed at</dt><dd>{{ exact(origin.sync.confirmed_at) }}</dd></div>
      <div v-if="origin.sync.next_attempt_at"><dt>Next attempt</dt><dd>{{ exact(origin.sync.next_attempt_at) }}</dd></div>
    </dl>
    <p v-if="error || origin.sync.error" role="alert">{{ error || origin.sync.error }}</p>
    <app-button v-if="origin.can_retry" :disabled="pending" @click.native="retry">{{ pending ? 'Queuing…' : 'Retry assignment' }}</app-button>
  </section>
</template>

<script>
import { postLeadTrengoAssignmentRetry } from '@/http'
import { formatExactDate } from '@/views/crm/task-tracker/leadFlowDate'

export default {
  name: 'LeadTrengoOrigin',
  props: { origin: { type: Object, required: true }, leadId: { type: Number, required: true } },
  data() { return { pending: false, error: '', refreshTimer: null } },
  mounted() {
    this.refreshTimer = setInterval(() => {
      if (['pending', 'running', 'retry_wait'].includes(this.origin.sync.status)) this.$emit('refresh')
    }, 15000)
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  computed: {
    ticketUrl() {
      return `https://app.trengo.com/tickets/${encodeURIComponent(this.origin.ticket_id)}`
    },
    statusLabel() {
      return ({ waiting_for_claim: 'Waiting for Take in Work', not_required: 'Existing Trengo assignment', pending: 'Queued', running: 'Running', retry_wait: 'Retry scheduled', confirmed: 'Confirmed', failed: 'Failed', unknown: 'Result unknown', superseded: 'Superseded' })[this.origin.sync.status] || this.origin.sync.status
    }
  },
  methods: {
    exact: formatExactDate,
    async retry() {
      if (this.pending || !this.origin.can_retry) return
      this.pending = true
      this.error = ''
      try {
        await postLeadTrengoAssignmentRetry(this.leadId)
        this.$emit('refresh')
      } catch (error) {
        this.error = (error.response && error.response.data && error.response.data.details) || 'Unable to retry Trengo assignment.'
      } finally {
        this.pending = false
      }
    }
  }
}
</script>

<style scoped>
p[role="alert"] { color: #bd394b; }
</style>
